import { NgModule } from '@angular/core';
import {
  NbButtonModule,
  NbCardModule,
  NbProgressBarModule,
  NbTabsetModule,
  NbUserModule,
  NbIconModule,
  NbSelectModule,
  NbListModule,
} from '@nebular/theme';
import { NgxEchartsModule } from 'ngx-echarts';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ThemeModule } from '../../../@theme/theme.module';
import { ChartModule } from 'angular2-chartjs';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { LegendChartComponent } from './legend-chart/legend-chart.component';
import { TransactionsChartHeaderComponent } from './transactions-chart/transactions-chart-header/transactions-chart-header.component';
import { TransactionsChartSummaryComponent } from './transactions-chart/transactions-chart-summary/transactions-chart-summary.component';
import { OrdersChartComponent } from './transactions-chart/charts/line-chart.component';
import { ProfitChartComponent } from './transactions-chart/charts/bar-chart.component';
import { TransactionsChartsComponent } from './transactions-chart/transactions-charts.component';
import { DashboardComponent } from './dashboard.component';
import { LatestSalesComponent } from './latest-sales/latest-sales.component';
import { LatestSalesCardComponent } from './latest-sales/card/latest-sales-card.component';


@NgModule({
  imports: [
    ThemeModule,
    NbCardModule,
    NbUserModule,
    NbButtonModule,
    NbIconModule,
    NbTabsetModule,
    NbSelectModule,
    NbListModule,
    ChartModule,
    NbProgressBarModule,
    NgxEchartsModule,
    NgxChartsModule,
    LeafletModule,
  ],
  declarations: [
    TransactionsChartsComponent,
    TransactionsChartHeaderComponent,
    TransactionsChartSummaryComponent,
    OrdersChartComponent,
    ProfitChartComponent,
    LegendChartComponent,
    DashboardComponent,
    LatestSalesComponent,
    LatestSalesCardComponent
  ]
})
export class DashboardModule {
}
